// (c) Copyright 2025 Hewlett Packard Enterprise Development LP

import { useNavigate } from "react-router-dom"
import { routes } from "../shell-routes.js"
import { getMfeBaseUrlPath, isShellMfe } from "../utils/env.js"

export function usePrefixedNavigate() {
  const navigate = useNavigate()

  return (to, options) => {
    const matchedConfig = Object.values(routes).find(({ navPath }) =>
      navPath.startsWith(to)
    )
    const isFrameMfe = matchedConfig?.isMfe
    if (isShellMfe && isFrameMfe) {
      navigate(`${getMfeBaseUrlPath()}${to}`, options)
      return
    }
    if (!isShellMfe && isFrameMfe) {
      window.location.href = `${window.$env.REACT_APP_MFE_REGION_URL}${to}`
      return
    }
    if (isShellMfe && !isFrameMfe) {
      window.location.href = `${window.$env.REACT_APP_STORAGE_SHELL_URL}${to}`
      return
    }

    navigate(to, options)
  }
}
